// @flow
import { getStorageItem, setStorageItem, removeStorageItem } from 'common/utils/StorageApi';

export class Settings {
  settings: { [key: string]: * } = {};

  constructor() {
    this.sync();

    window.addEventListener(
      'storage',
      () => {
        this.sync();
      },
      false,
    );
  }

  sync(): void {
    this.settings = getStorageItem('settings');
  }

  set(name: string, value: *): void {
    this.settings = {
      ...this.settings,
      [name]: value,
    };

    setStorageItem('settings', this.settings);
  }

  get(name: string): * {
    const path = name.split('.');
    const { length } = path;

    let settings = {
      ...this.settings,
    };

    for (let i = 0; i < length; i++) {
      if (!settings[path[i]]) {
        return undefined;
      }

      settings = settings[path[i]];
    }

    return settings;
  }

  remove(name: string): void {
    delete this.settings[name];

    setStorageItem('settings', this.settings);
  }

  destroy(): void {
    this.settings = {};
    removeStorageItem('settings');
  }
}

export default new Settings();



// WEBPACK FOOTER //
// ./src/settings/Settings.js